export default function Loading() {
    return (
        <div className="loading-state">
            <div className="loading"></div>
        </div>  
    )
}